webpackJsonp([35783957827783],{

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(26);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(42);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(41);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(72);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(71);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  var _props$opacity = props.opacity,
	      opacity = _props$opacity === undefined ? "" : _props$opacity,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$sizes = props.sizes,
	      sizes = _props$sizes === undefined ? "" : _props$sizes,
	      _props$title = props.title,
	      title = _props$title === undefined ? "" : _props$title,
	      _props$alt = props.alt,
	      alt = _props$alt === undefined ? "" : _props$alt,
	      _props$width = props.width,
	      width = _props$width === undefined ? "" : _props$width,
	      _props$height = props.height,
	      height = _props$height === undefined ? "" : _props$height,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela;
	
	  return "<img width=" + width + " height=" + height + " src=\"" + src + "\" srcset=\"" + srcSet + "\" alt=\"" + alt + "\" title=\"" + title + "\" sizes=\"" + sizes + "\" style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;objectPosition:center\"/>";
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela2 = props.transitionDelay,
	      transitionDelay = _props$transitionDela2 === undefined ? "" : _props$transitionDela2,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.35s"
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: ""
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func
	};
	
	exports.default = Image;

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  transition: opacity .3s ease-in-out;\n  &:hover {\n    opacity: .7;\n  }\n'], ['\n  transition: opacity .3s ease-in-out;\n  &:hover {\n    opacity: .7;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  margin: 0;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  h3 {\n    align-self: flex-end;\n    text-align: right;\n  }\n\n'], ['\n  position: relative;\n  margin: 0;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  h3 {\n    align-self: flex-end;\n    text-align: right;\n  }\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n\n'], ['\n\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex: 1;\n  justify-content: flex-end;\n'], ['\n  display: flex;\n  flex: 1;\n  justify-content: flex-end;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  background-color: #4F4F4F;\n  margin-left: 10px;\n  margin-right: 10px;\n  height: 1px;\n  width: 100%;\n  max-width: 25px;\n  flex: 1;\n'], ['\n  background-color: #4F4F4F;\n  margin-left: 10px;\n  margin-right: 10px;\n  height: 1px;\n  width: 100%;\n  max-width: 25px;\n  flex: 1;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 150px;\n\n  @media only screen and (max-width: 800px) {\n    margin: 110px;\n  }\n'], ['\n  margin-bottom: 150px;\n\n  @media only screen and (max-width: 800px) {\n    margin: 110px;\n  }\n']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(92);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(40);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(91);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var gridLayout = [{ grid: "col-lg-offset-8 col-lg-3 col-md-offset-6 col-md-6 col-xs-offset-2 col-xs-10", rise: false }, //Beauty
	{ grid: "col-lg-offset-1 col-lg-3 col-md-offset-0 col-md-4 col-xs-8", rise: true }, // Zombie Boy
	{ grid: "col-lg-offset-7 col-lg-2 col-md-offset-6 col-md-5 col-xs-offset-3 col-xs-9", rise: false }, // Lucrece
	{ grid: "col-lg-offset-0 col-lg-4 col-md-offset-1 col-md-4 col-xs-8", rise: false }, // Eve
	{ grid: "col-lg-offset-8 col-lg-3 col-md-offset-6 col-md-6 col-xs-offset-3 col-xs-9", rise: true }, //Dissembled
	{ grid: "col-lg-offset-2 col-lg-2 col-md-offset-1 col-md-4 col-xs-8", rise: false }, // Crystal
	{ grid: "col-lg-offset-7 col-lg-3 col-md-offset-7 col-md-5 col-xs-offset-2 col-xs-10", rise: false }, // Colour / OG Collection Ends <3
	{ grid: "col-lg-offset-1 col-lg-4 col-md-offset-2 col-md-4 col-xs-offset-4 col-xs-8", rise: true }, //Beauty
	{ grid: "col-lg-offset-8 col-lg-3 col-md-offset-8 col-md-4 col-xs-9", rise: true }, // Zombie Boy
	{ grid: "col-lg-offset-3 col-lg-2 col-md-offset-1 col-md-5 col-xs-offset-4 col-xs-8", rise: false }, // Lucrece
	{ grid: "col-lg-offset-7 col-lg-3 col-md-offset-7 col-md-5 col-xs-offset-2 col-xs-10", rise: false }, // Eve
	{ grid: "col-lg-offset-1 col-lg-3 col-md-offset-0 col-md-6 col-xs-8", rise: true }, //Dissembled
	{ grid: "col-lg-offset-8 col-lg-2 col-md-offset-7 col-md-5 col-xs-offset-3 col-xs-9", rise: false }, // Crystal
	{ grid: "col-lg-offset-2 col-lg-3 col-md-offset-1 col-md-4 col-xs-10", rise: false }, // Colour
	{ grid: "col-lg-offset-8 col-lg-3 col-md-offset-7 col-md-5 col-xs-offset-4 col-xs-8", rise: true }, //Beauty
	{ grid: "col-lg-offset-1 col-lg-3 col-md-offset-0 col-md-4 col-xs-10", rise: false }, // Zombie Boy
	{ grid: "col-lg-offset-7 col-lg-2 col-md-offset-6 col-md-4 col-xs-8", rise: false }, // Lucrece
	{ grid: "col-lg-offset-2 col-lg-3 col-md-offset-1 col-md-6 col-xs-offset-3 col-xs-9", rise: false }, // Eve
	{ grid: "col-lg-offset-8 col-lg-4 col-md-offset-8 col-md-4 col-xs-offset-4 col-xs-8", rise: true }, //Dissembled
	{ grid: "col-lg-offset-1 col-lg-2 col-md-offset-0 col-md-5 col-xs-10", rise: false }, // Crystal
	{ grid: "col-lg-offset-7 col-lg-3 col-md-offset-7 col-md-5 col-xs-offset-3 col-xs-9", rise: false }];
	
	var GalleryLinkContainer = _styledComponents2.default.div(_templateObject);
	
	var TitleBox = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.h2(_templateObject3);
	
	var LineBox = _styledComponents2.default.div(_templateObject4);
	
	var Line = _styledComponents2.default.div(_templateObject5);
	
	var TopMargin = _styledComponents2.default.div(_templateObject6);
	
	var Row = function Row(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: props.rise ? 'row rise' : 'row' },
	    props.children
	  );
	};
	
	var GalleryLink = function GalleryLink(props) {
	  return _react2.default.createElement(
	    Row,
	    { rise: gridLayout[props.gridLayout].rise },
	    _react2.default.createElement(
	      GalleryLinkContainer,
	      { className: gridLayout[props.gridLayout].grid },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: props.slug },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: props.thumbnailImageSizes,
	          backgroundColor: "#f2f2f2",
	          fadeIn: true })
	      ),
	      _react2.default.createElement(
	        TitleBox,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          props.title
	        ),
	        _react2.default.createElement(
	          LineBox,
	          null,
	          _react2.default.createElement(Line, null)
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.number
	        )
	      )
	    )
	  );
	};
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	
	  var gallery = data.allContentfulGallery.edges;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'main',
	      { className: 'animated fadeInUp' },
	      _react2.default.createElement(TopMargin, null),
	      gallery.map(function (_ref2, i) {
	        var node = _ref2.node;
	        return _react2.default.createElement(GalleryLink, {
	          gridLayout: i,
	          key: i,
	          slug: node.fields.slug,
	          title: node.title.toUpperCase(),
	          number: ("0" + (i + 1)).slice(-2),
	          thumbnailImageSizes: node.thumbnailImage.sizes });
	      }),
	      _react2.default.createElement('div', { className: 'row push' })
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-207a048ed8a72852878d.js